import { Link, useNavigate } from "react-router-dom";
import "./AfficheProduit.css";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import { useContext, useState, useEffect } from "react";
import { MagasinContext } from "../../../Context/MagasinContext";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";
import defaultImg from "../../Admin/IMG/DefaulteImage.jpeg";
import axios from "axios";
import EmptyCartPopup from "../../../components/EmptyCartPopup";

interface Product {
  id: string;
  designation: string;
  imageUrl: string;
  prix: string;
  NomMarque:any;
  Quantité: any;
  quantity: number;
  refArticle: any;
  NomMagasin: any;
}

const AfficheProduitByIdCommercial: React.FC<ArticleInfo> = ({
  IdArticle,
  Designation,
  NomMagasin,
  PrixVenteArticleTTC,
  Description,
  image,
  stock,
  quantité,
  RefArticle,
  LibelleSubstitut,
  prix_ht_2_magasin,
  prix_ht_3_magasin,
  prix_ht_1_magasin,
  NomMarque,
  QantityMagasin,
}) => {
  // Helper to parse numeric stock from any format ("32", 32, " 32 ", "32.0", etc.)
  const parseQty = (val: any): number | null => {
    if (val === undefined || val === null || val === "") return null;
    const clean = String(val).replace(",", ".").trim();
    if (clean === "") return null;
    const n = parseFloat(clean);
    return isNaN(n) ? null : n;
  };

  // Resolve quantity from all possible prop sources: quantité, stock, or QantityMagasin
  const parsedQty = parseQty(quantité) ?? parseQty(stock) ?? parseQty(QantityMagasin) ?? 0;
  const resolvedQty = Math.max(0, parsedQty);
  const RemiseCommercial = localStorage.getItem("remise") || "";
  const [products, setProducts] = useState<Product[]>([]);
  const [value, setValue] = useState(1);
  const [message, setMessage] = useState("");
  const [addingToCart, setAddingToCart] = useState(false);
  const handleGoBack = () => window.history.back();
  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("CommercialId");
  const CommercialName = localStorage.getItem("CommercialName");
  const MagasinName = localStorage.getItem("MagasinName");
  const id = MagasinId || magasinContext.id?.id;
  const navigate = useNavigate();

  const [cartLength, setCartLength] = useState(0);
  const [showEmptyCartPopup, setShowEmptyCartPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [commissionRules, setCommissionRules] = useState<any[]>([]);

  const fetchCartLength = async () => {
    if (!MagasinId) return;
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_PHP_APP_URL}/panier/visiteur/${MagasinId}/commercials`
      );
      setCartLength(Array.isArray(data) ? data.length : 0);
    } catch (e) {
      console.error("Error fetching cart length:", e);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      
      const fetchCommission = async () => {
        try {
          const { default: axios } = await import("axios");
          const r = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/commission`);
          setCommissionRules(r.data || []);
        } catch {
          setCommissionRules([]);
        }
      };

      await Promise.all([
        fetchCartLength(),
        fetchCommission()
      ]);
      
      setLoading(false);
    };

    loadData();
    
    const handleCartUpdate = () => {
      fetchCartLength();
    };
    window.addEventListener("panier-updated", handleCartUpdate);
    return () => {
      window.removeEventListener("panier-updated", handleCartUpdate);
    };
  }, [MagasinId]);

  const addProductToPanier = async (
    id: string,
    image: string,
    designation: string,
    prix: string,
    Quantité: any,
    refArticle: any,
    NomMagasin: any
  ) => {
    setAddingToCart(true);
    try {
      const fd = new FormData();
      fd.append("IdUtilisateur",   MagasinId || "");
      fd.append("TypeUtilisiteur", "commercials");
      fd.append("IdArticle",       String(IdArticle ?? id));
      fd.append("RefArticle",      refArticle || "");
      fd.append("Designation",     designation);
      fd.append("Image",           image || defaultImg || "");
      fd.append("price",           String(prix));
      fd.append("quantity",        String(value));
      fd.append("NomMagasin",      NomMagasin || "");

      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier`, fd);
      
      window.dispatchEvent(new Event("panier-updated"));
      
      setMessage("Produit ajouté au panier avec succès !");
      
      setTimeout(() => {
        navigate(`/commercials/${MagasinId}`);
      }, 1500);

    } catch (error) {
      console.error("Error adding to cart:", error);
      setMessage("Erreur lors de l'ajout au panier. Veuillez réessayer.");
      setTimeout(() => setMessage(""), 3000);
    } finally {
      setAddingToCart(false);
    }
  };



  const getGlobalCommission = (): number => {
    const globalRule = commissionRules.find((r: any) => r.commission_type === "global");
    if (globalRule) return parseFloat(globalRule.commission_value) || 0;
    return 0;
  };

  const getMagasinCommission = (nomMagasin?: string): number => {
    if (!nomMagasin) return 0;
    const magasinRule = commissionRules.find(
      (r: any) =>
        r.commission_type === "magasin_all" &&
        r.source_magasin_name?.toLowerCase() === nomMagasin?.toLowerCase()
    );
    if (magasinRule) return parseFloat(magasinRule.commission_value) || 0;
    return 0;
  };

  // Commercials are not product owners — they always see the commission-applied price
  const isMine = false;
  const remise = parseFloat((localStorage.getItem("remise") || "0").replace("%", "")) || 0;
  const prixHT = parseFloat(String(PrixVenteArticleTTC ?? "0").replace(",", ".").trim()) || 0;
  const commissionWyn = getGlobalCommission();

  // Prix ancien (barré) = prix_original × (1 + commission_globale%) × (1 + remise%)
  // Exemple: 131.52 × 1.03 × 1.05 = 142.23
  const oldPrice = remise > 0
    ? prixHT * (1 + commissionWyn / 100) * (1 + remise / 100)
    : prixHT * (1 + commissionWyn / 100);

  // Prix final = prix ancien × (1 - remise%)
  // Exemple: 142.23 × 0.95 = 135.12
  const newPrice = remise > 0
    ? oldPrice * (1 - remise / 100)
    : oldPrice;

  // Show old price crossed-out only when there is a remise
  const showOldPrice = remise > 0 && prixHT > 0;

  const calculatePrice = () => {
    return newPrice.toFixed(2);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#FAFAFA' }}>
        <div style={{ width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #F5A623', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
        <span style={{ marginTop: '16px', color: '#64748B', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>Chargement des données...</span>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <>
      <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
      <NewSidebareCommercial />
      <div className="page-wrapper-dpnd-commercial-u">
        <div className="page-inner-dpnd-commercial-u">
          {/* Success message */}
          {message && (
            <div style={{
              background: 'linear-gradient(135deg, #ECFDF5, #D1FAE5)',
              border: '1.5px solid #6EE7B7',
              borderRadius: '12px',
              padding: '14px 20px',
              marginBottom: '20px',
              color: '#065F46',
              fontWeight: 600,
              fontSize: '0.88rem',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              animation: 'fadeInProd 0.3s ease'
            }}>
              <i className="bi bi-check-circle-fill"></i> {message}
            </div>
          )}

          {/* Back + Cart Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px'
          }}>
            <button
              onClick={handleGoBack}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '10px 18px',
                borderRadius: '12px',
                border: '1.5px solid #E2E8F0',
                background: '#FFFFFF',
                color: '#334155',
                fontFamily: "'Inter', sans-serif",
                fontSize: '0.85rem',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
            >
              <i className="bi bi-arrow-left"></i> Retour
            </button>

            <button
              onClick={() => cartLength === 0 ? setShowEmptyCartPopup(true) : navigate(`/commercials/${id}/panier`)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 18px',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #F5A623, #E8930C)',
                color: '#fff',
                fontFamily: "'Inter', sans-serif",
                fontSize: '0.85rem',
                fontWeight: 600,
                textDecoration: 'none',
                boxShadow: '0 4px 16px rgba(245,166,35,0.3)',
                position: 'relative',
                border: 'none',
                cursor: 'pointer'
              }}
            >
              <i className="bi bi-cart3"></i> Panier
              {cartLength > 0 && (
                <span style={{
                  background: '#EF4444',
                  color: '#fff',
                  fontSize: '0.65rem',
                  fontWeight: 700,
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'absolute',
                  top: '-6px',
                  right: '-6px'
                }}>
                  {cartLength}
                </span>
              )}
            </button>
          </div>

          {/* Product Detail Card */}
          <div style={{
            background: '#FFFFFF',
            borderRadius: '20px',
            border: '1.5px solid #E2E8F0',
            boxShadow: '0 4px 16px rgba(15,23,42,0.06)',
            overflow: 'hidden',
            display: 'grid',
            gridTemplateColumns: window.innerWidth > 768 ? '380px 1fr' : '1fr',
            gap: '0'
          }}>
            {/* Image */}
            <div style={{
              background: 'linear-gradient(135deg, #F8FAFC, #F1F5F9)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '40px',
              minHeight: '300px'
            }}>
              <img
                src={image || defaultImg}
                alt={Designation}
                style={{
                  maxWidth: '100%',
                  maxHeight: '260px',
                  objectFit: 'contain',
                  borderRadius: '12px',
                  filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.08))'
                }}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = defaultImg;
                }}
              />
            </div>

            {/* Info */}
            <div style={{ padding: '32px' }}>
              <h2 style={{
                fontSize: '1.4rem',
                fontWeight: 700,
                color: '#0F172A',
                marginBottom: '6px',
                letterSpacing: '-0.01em'
              }}>
                {Designation}
              </h2>

              <p style={{
                fontSize: '0.78rem',
                color: '#94A3B8',
                marginBottom: '20px',
                fontFamily: "'Courier New', monospace",
                letterSpacing: '0.04em'
              }}>
                Réf: {RefArticle}
              </p>

              {/* Price */}
              <div style={{
                background: 'linear-gradient(135deg, #FFF8E7, #FEF3C7)',
                borderRadius: '14px',
                padding: '16px 20px',
                marginBottom: '20px',
                border: '1px solid #FDE68A'
              }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '0.75rem', color: '#92400E', fontWeight: 500 }}>
                    Prix TTC
                  </span>
                  {/* Price display logic */}
                  {showOldPrice ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      {/* Prix ancien barré = prix avec commission + remise (avant réduction) */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ 
                          textDecoration: 'line-through', 
                          color: '#9CA3AF', 
                          fontSize: '1rem', 
                          fontWeight: 600 
                        }}>
                          {oldPrice.toFixed(2)} MAD
                        </span>
                        <span style={{
                          background: '#FEE2E2',
                          color: '#DC2626',
                          fontSize: '0.72rem',
                          fontWeight: 700,
                          padding: '2px 8px',
                          borderRadius: '20px'
                        }}>
                          -{Math.round(remise)}%
                        </span>
                      </div>
                      {/* Prix final après remise */}
                      <div style={{
                        fontSize: '1.8rem',
                        fontWeight: 800,
                        background: 'linear-gradient(135deg, #F5A623, #E8930C)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        lineHeight: 1.2
                      }}>
                        {calculatePrice()} <span style={{ fontSize: '0.9rem' }}>MAD</span>
                      </div>
                    </div>
                  ) : (
                    <div style={{
                      fontSize: '1.8rem',
                      fontWeight: 800,
                      background: 'linear-gradient(135deg, #F5A623, #E8930C)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      lineHeight: 1.2
                    }}>
                      {calculatePrice()} <span style={{ fontSize: '0.9rem' }}>MAD</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Product Specifications Grid */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '12px',
                marginBottom: '20px'
              }}>
                {[
                  { label: 'Référence', value: RefArticle, icon: 'bi-hash' },
                  { label: 'Marque', value: NomMarque || 'N/A', icon: 'bi-bookmark-star' },
                  { label: 'Remise', value: remise > 0 ? `-${remise}%` : 'Aucune', icon: 'bi-percent' },
                ].map((item, i) => (
                  <div key={i} style={{
                    background: '#F8FAFC',
                    borderRadius: '12px',
                    padding: '12px',
                    border: '1.5px solid #E2E8F0',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '4px'
                  }}>
                    <i className={`bi ${item.icon}`} style={{ color: '#F5A623', fontSize: '1.1rem' }}></i>
                    <div style={{ fontSize: '0.65rem', color: '#64748B', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.02em' }}>
                      {item.label}
                    </div>
                    <div style={{ fontSize: '0.85rem', fontWeight: 700, color: '#0F172A' }}>
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>

              {/* Stock Status */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '20px',
                padding: '10px 14px',
                background: (Number(resolvedQty || 0) <= 0) ? '#FEF2F2' : '#F0FDF4',
                borderRadius: '10px',
                border: (Number(resolvedQty || 0) <= 0) ? '1px solid #FCA5A5' : '1px solid #BBF7D0'
              }}>
                <i className={`bi ${Number(resolvedQty || 0) <= 0 ? 'bi-x-circle' : 'bi-check-circle'}`} 
                   style={{ color: Number(resolvedQty || 0) <= 0 ? '#DC2626' : '#16A34A' }}></i>
                <span style={{ 
                  fontSize: '0.85rem', 
                  fontWeight: 600, 
                  color: Number(resolvedQty || 0) <= 0 ? '#B91C1C' : '#15803D' 
                }}>
                  {Number(resolvedQty || 0) <= 0 ? "Stock épuisé" : "En stock"}
                </span>
              </div>

              {/* Quantity */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '24px',
                opacity: (Number(resolvedQty || 0) <= 0) ? 0.5 : 1,
                pointerEvents: (Number(resolvedQty || 0) <= 0) ? 'none' : 'auto'
              }}>
                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#334155' }}>
                  Quantité
                </label>
                <input
                  type="number"
                  min={1}
                  max={resolvedQty > 0 ? resolvedQty : undefined}
                  value={value}
                  onChange={(e: any) => setValue(e.target.value)}
                  style={{
                    width: '80px',
                    padding: '10px 12px',
                    borderRadius: '10px',
                    border: '1.5px solid #E2E8F0',
                    fontSize: '0.9rem',
                    fontWeight: 600,
                    textAlign: 'center',
                    fontFamily: "'Inter', sans-serif",
                    outline: 'none',
                    transition: 'border-color 0.2s',
                    color: '#0F172A',
                    backgroundColor: '#FFFFFF'
                  }}
                />
              </div>

              {/* Add to cart button */}
              <button
                disabled={addingToCart || (Number(resolvedQty || 0) <= 0)}
                onClick={() => {
                  const prixFinal = calculatePrice();
                  addProductToPanier(
                    RefArticle,
                    image,
                    Designation,
                    prixFinal,
                    resolvedQty,
                    RefArticle,
                    NomMagasin
                  );
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  width: '100%',
                  padding: '14px',
                  borderRadius: '14px',
                  background: (Number(resolvedQty || 0) <= 0) ? '#94A3B8' : 'linear-gradient(135deg, #F5A623, #E8930C)',
                  color: '#fff',
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  border: 'none',
                  cursor: (addingToCart || (Number(resolvedQty || 0) <= 0)) ? 'not-allowed' : 'pointer',
                  boxShadow: (Number(resolvedQty || 0) <= 0) ? 'none' : '0 6px 20px rgba(245,166,35,0.35)',
                  transition: 'all 0.25s ease',
                  opacity: addingToCart ? 0.8 : 1
                }}
              >
                {addingToCart ? (
                  <><span style={{
                    display: 'inline-block', width: 16, height: 16,
                    border: '2.5px solid rgba(255,255,255,0.3)',
                    borderTopColor: '#fff', borderRadius: '50%',
                    animation: 'spinC 0.65s linear infinite'
                  }} /> Ajout...</>
                ) : (Number(resolvedQty || 0) <= 0) ? (
                  <><i className="bi bi-x-circle"></i> Stock épuisé</>
                ) : (
                  <><i className="bi bi-cart-plus"></i> Ajouter au panier</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AfficheProduitByIdCommercial;